import { render, staticRenderFns } from "./GruposAlerta.vue?vue&type=template&id=6e2c5205&scoped=true&lang=pug"
import script from "./GruposAlerta.vue?vue&type=script&lang=js"
export * from "./GruposAlerta.vue?vue&type=script&lang=js"
import style0 from "./GruposAlerta.vue?vue&type=style&index=0&id=6e2c5205&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2c5205",
  null
  
)

export default component.exports